var map = {
	"./1.png": 899,
	"./10 - Copy.png": 900,
	"./10.png": 901,
	"./11.png": 902,
	"./12.png": 903,
	"./13.png": 904,
	"./14.png": 905,
	"./15.png": 906,
	"./16.png": 907,
	"./17.png": 908,
	"./18.png": 909,
	"./19.png": 910,
	"./2.png": 911,
	"./20.png": 912,
	"./21.png": 913,
	"./22.png": 914,
	"./24.png": 915,
	"./25.png": 916,
	"./26.png": 917,
	"./27.png": 918,
	"./28.png": 919,
	"./29.png": 920,
	"./31.png": 921,
	"./32.png": 922,
	"./33.png": 375,
	"./34.png": 923,
	"./35.png": 376,
	"./35_old.png": 924,
	"./4.png": 925,
	"./5.png": 926,
	"./6.png": 927,
	"./7.png": 928,
	"./8.png": 929,
	"./9.png": 930,
	"./AAVE.png": 931,
	"./ALCRYP.png": 932,
	"./AMZN.png": 933,
	"./APPL.png": 934,
	"./BCH.png": 935,
	"./BCM.png": 936,
	"./BEAM.png": 937,
	"./BNB.png": 938,
	"./BTC.png": 939,
	"./BTCB.png": 940,
	"./BUSD.png": 941,
	"./CAKE.png": 942,
	"./CHZ.png": 943,
	"./CRYC10.png": 944,
	"./DAI.png": 945,
	"./DOGE.png": 946,
	"./DOT.png": 947,
	"./EPS.png": 948,
	"./EQSTK.png": 949,
	"./ETH.png": 950,
	"./FTM.png": 951,
	"./FTT.png": 952,
	"./GOOGL.png": 953,
	"./IBAT.png": 954,
	"./IN500.png": 955,
	"./INDXXF.png": 956,
	"./INEX.png": 381,
	"./INJ.png": 957,
	"./INXC.png": 958,
	"./INXP.png": 959,
	"./IUSD+.png": 177,
	"./IUSD+_old.png": 960,
	"./IUSD.png": 961,
	"./IUSDP.png": 962,
	"./IUSDP_OLD.png": 963,
	"./IUSD_old.png": 964,
	"./LBlock.png": 965,
	"./LEO.png": 966,
	"./LINK.png": 967,
	"./LTC.png": 968,
	"./MANA.png": 969,
	"./MATIC.png": 970,
	"./META.png": 971,
	"./MSFT.png": 972,
	"./NEAR.png": 973,
	"./NOT.png": 974,
	"./NVDA.png": 975,
	"./PEP.png": 976,
	"./PYTH.png": 977,
	"./RUNE.png": 978,
	"./SHIB.png": 979,
	"./SNP500.png": 980,
	"./SOL.png": 981,
	"./TLSA.png": 982,
	"./TOB.png": 983,
	"./TON.png": 984,
	"./TRX.png": 985,
	"./TUSD.png": 986,
	"./USD.png": 987,
	"./USDC.png": 988,
	"./USDT.png": 989,
	"./WIBS.png": 990,
	"./XRP.png": 991,
	"./eth new PP lpgo 1.png": 992,
	"./inxf.png": 993
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 109;